import { render } from "./AdminNoticeView.vue?vue&type=template&id=88208af0&scoped=true"
import script from "./AdminNoticeView.vue?vue&type=script&lang=js"
export * from "./AdminNoticeView.vue?vue&type=script&lang=js"

import "./AdminNoticeView.vue?vue&type=style&index=0&id=88208af0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88208af0"]])

export default __exports__